import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

let nextSectionId = 0;

@Component({
  selector: 'app-collapsible-section',
  templateUrl: './collapsible-section.component.html',
  styleUrls: ['./collapsible-section.component.less'],
  imports: [MatIconModule, NgTemplateOutlet],
  standalone: true
})
export class CollapsibleSectionComponent {
  @Input() heading = '';
  @Input() count: number | null = null;
  @Input() collapsible = true;
  @Input() expanded = true;

  @Output() expandedChange = new EventEmitter<boolean>();

  readonly bodyId = `collapsible-section-body-${nextSectionId++}`;

  get isCollapsed(): boolean {
    return this.collapsible && !this.expanded;
  }

  toggle(): void {
    if (!this.collapsible) {
      return;
    }
    this.expanded = !this.expanded;
    this.expandedChange.emit(this.expanded);
  }
}
